import { Box } from "@material-ui/core";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Forbidden() {
    const { t } = useTranslation();
    useEffect(() => {
        localStorage.removeItem("login_redirect");
    }, []);
    return (
        <Box textAlign="center" position="relative" top="30vh">
            <Box fontSize="40px">{t("common.forbidden.title")}</Box>
            <Box>
                {t("common.forbidden.content")}
                <Link to="/main">{t("common.forbidden.here")}</Link>
            </Box>
        </Box>
    );
}
